export default "__VITE_ASSET__CZu7g2a1__"